<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="DeleteTemperatureAutomation-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="DeleteTemperatureAutomation-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="DeleteTemperatureAutomation-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="DeleteTemperatureAutomation-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91s2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91s-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <path class="DeleteTemperatureAutomation-st2" d="M67.79,33.16h13.35c3.05,0,5.53,2.47,5.53,5.53V54.8c0,3.05-2.47,5.53-5.53,5.53H67.79c-3.05,0-5.53-2.47-5.53-5.53V38.68C62.26,35.63,64.73,33.16,67.79,33.16z"/>
            <path class="DeleteTemperatureAutomation-st3" d="M32.33,33.16h13.35c3.05,0,5.53,2.47,5.53,5.53V54.8c0,3.05-2.47,5.53-5.53,5.53H32.33c-3.05,0-5.53-2.47-5.53-5.53V38.68C26.8,35.63,29.28,33.16,32.33,33.16z"/>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.DeleteTemperatureAutomation_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.DeleteTemperatureAutomation_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="DeleteTemperatureAutomation-button lxn-margin-auto lxn-w100">
      <CustomButton  @click="DeleteTemperatureAutomation" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.DeleteTemperatureAutomation_button}}
      </CustomButton>
    </div>
    <div class="DeleteTemperatureAutomation-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next2" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true" textColor="#FFFFFF">
        {{$store.getters.language.texts.DeleteTemperatureAutomation_button2}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'


export default {
  name: 'DeleteTemperatureAutomation',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton
  },
  data: function () {
    return {
      widgetIndex: Math.floor(this.$route.params.widgetIndex),
    }
  },
  computed: {
    widget: function () {
      return this.$store.state.widgets[this.widgetIndex];
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    DeleteTemperatureAutomation: function () {
      this.$store.commit('setAppBusy', true);
      var hub = this.$store.getters.getHubByUUID(this.widget.hubUUID);

      if(!hub.isOwner){
        alert(this.$store.getters.language.texts.DeleteTemperatureAutomation_alertNotOwner);
        this.$store.commit('setAppBusy', false);
        return;
      }
      if(this.widget.type != 'temperatureAutomationWidget'){
        return;
      }

      //eventId for cool on
      var coolOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3);
      //dummy eventId for cool on
      var coolOnDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 4;

      //eventId for cool off
      var coolOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 1;
      //dummy eventId for cool off
      var coolOffDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 5;

      //eventId for heat on
      var heatOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 2;
      //dummy eventId for heat on
      var heatOnDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 6;

      //eventId for heat off
      var heatOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 3;
      //dummy eventId for heat off
      var heatOffDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 7;


      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });

      this.$store.dispatch('readHubWatches', {
        messagingHook: messagingHook,
        hubUUID: hub.uuid,
      })
      .then( (response) => {
        var watchList = response.body.bodyContent.watchList;
        var newWatchList = [];
        for(var i = 0; i < watchList.length; i++){
          if(watchList[i].eventId != coolOnActualEventId && watchList[i].eventId != coolOffActualEventId && watchList[i].eventId != heatOnActualEventId && watchList[i].eventId != heatOffActualEventId){
            newWatchList.push(watchList[i]);
          }
        }
        this.$store.dispatch('setWatchOnHub', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
          bodyContent: {
            watchList: newWatchList,
          }
        })
        .then( () => {
          var maskList = [];
          maskList.push({
            eventId: coolOnActualEventId,
            isMasked: false,
          });
          maskList.push({
            eventId: coolOffActualEventId,
            isMasked: false,
          });
          maskList.push({
            eventId: heatOnActualEventId,
            isMasked: false,
          });
          maskList.push({
            eventId: heatOffActualEventId,
            isMasked: false,
          });
          this.$store.dispatch('setEventMasks', {
            messagingHook: messagingHook,
            hubUUID: hub.uuid,
            bodyContent: {
              maskList: maskList
            }
          })
          .then( () => {
            var instructionsList = [];
            instructionsList.push({
              eventIdToWatch: coolOnActualEventId
            });
            instructionsList.push({
              eventIdToWatch: coolOffActualEventId
            });
            instructionsList.push({
              eventIdToWatch: heatOnActualEventId
            });
            instructionsList.push({
              eventIdToWatch: heatOffActualEventId
            });
            this.$store.dispatch('deleteHubInstructionsByEventId', {
              messagingHook: messagingHook,
              hubUUID: hub.uuid,
              bodyContent: {
                instructionsList: instructionsList
              }
            })
            .then( () => {
              this.$store.dispatch('readNodeInstructions', {
                messagingHook: messagingHook,
                hubUUID: hub.uuid,
                nodeUUID: this.widget.settings.sensorUUID
              })
              .then( response => {
                var sensorInstructionList = response.body.bodyContent.instructionList;
                var newSensorInstructionList = [];
                for(var i = 0; i < sensorInstructionList.length; i++){
                  if(sensorInstructionList[i].internalAction.valueOfChange != coolOnDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != coolOffDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != heatOnDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != heatOffDummyEventId){
                    newSensorInstructionList.push(sensorInstructionList[i]);
                  }
                }
                this.$store.dispatch('setInstructionsOnDevice', {
                  messagingHook: messagingHook,
                  hubUUID: hub.uuid,
                  nodeUUID: this.widget.settings.sensorUUID,
                  instructions: newSensorInstructionList,
                })
                .then( () => {
                  //It was successfull!!! Do nothing.
                })
                .catch( () => {
                  alert(this.$store.getters.language.texts.DeleteTemperatureAutomation_alertSensorFailed);
                })
                .finally( () => {
                  this.$router.push('/home/dashboard/');
                  this.$store.commit('setAppBusy', false);
                })
              })
              .catch( () => {
                alert(this.$store.getters.language.texts.DeleteTemperatureAutomation_alertSensorFailed);
                this.$router.push('/home/dashboard/');
                this.$store.commit('setAppBusy', false);
              })
              .finally( () => {
                this.$store.commit('deleteWidget', this.widgetIndex);
                this.$store.commit('saveState');
              })
            })
            .catch( response => {
              if(response.rejectCode == 2){
                this.$store.commit('setHubStatus', {
                  hubIndex: response.hubIndex,
                  connectionStatus: {
                    local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                    online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  },
                });
                this.$router.push('/DeleteDeviceHubError');
              }else{
                alert(this.$store.getters.language.texts.DeleteTemperatureAutomation_alertDeleteError);
              }
              this.$store.commit('setAppBusy', false);
            })
          })
          .catch( response => {
            if(response.rejectCode == 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
              this.$router.push('/DeleteDeviceHubError');
            }else{
              alert(this.$store.getters.language.texts.DeleteTemperatureAutomation_alertDeleteError);
            }
            this.$store.commit('setAppBusy', false);
          })
        })
        .catch( response => {
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
            this.$router.push('/DeleteDeviceHubError');
          }else{
            alert(this.$store.getters.language.texts.DeleteTemperatureAutomation_alertDeleteError);
            this.$router.push('/home/dashboard/');
          }
          this.$store.commit('setAppBusy', false);
        })
      })
      .catch( response => {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
          this.$router.push('/DeleteDeviceHubError');
        }else{
          alert(this.$store.getters.language.texts.DeleteTemperatureAutomation_alertDeleteError);
          this.$router.push('/home/dashboard/');
        }
        this.$store.commit('setAppBusy', false);
      })
    },
    next2: function () {
      this.$router.go(-1);
    }
  }
}
</script>

<style>
  .DeleteTemperatureAutomation-topCurve-wrapper {
    height: 200px;
  }
  .DeleteTemperatureAutomation-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .DeleteTemperatureAutomation-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.DeleteTemperatureAutomation-st0 {
    fill: #ECECEC;
  }
	.DeleteTemperatureAutomation-st1 {
    fill: #53636C;
  }
	.DeleteTemperatureAutomation-st2 {
    fill: #1EA5DE;
  }
	.DeleteTemperatureAutomation-st3 {
    fill: #F36C4F;
  }
</style>
